import {
  corsUrlsFromBaseUrls,
  deploymentEnvironmentForMode,
  initTelemetry,
} from "@tastyworks/shared-web-telemetry/telemetry"
import { honeycombUiForMode } from "@tastyworks/shared-web-telemetry/sentry-correlation"
import session from "$lib/tastyworks-rest/session"

let started = false

// OpenTelemetry tracing for start.tastytrade.com, gated by the `ao2-otel` flag.
// Called from the root +layout once the LD client is ready. No-op unless the
// endpoint is set; URL PII is handled by the redaction processor, not ordering.
export function maybeInitTelemetry(otelEnabled: boolean): void {
  // The root layout load can re-run; register the tracer provider only once.
  if (!otelEnabled || started) {
    return
  }
  started = true

  // Runs inside the SvelteKit root load(), so guard it — a telemetry failure
  // must not crash boot. `started` is set above so a failure isn't retried.
  try {
    initTelemetry({
      endpoint: import.meta.env.VITE_HONEYCOMB_ENDPOINT,
      serviceName: "web-account-opening",
      serviceVersion: __APP_VERSION__,
      deploymentEnvironment: deploymentEnvironmentForMode(import.meta.env.MODE),
      resourceAttributes: { "telemetry.source": "browser" },
      honeycombUi: honeycombUiForMode(import.meta.env.MODE),
      propagateTraceHeaderCorsUrls: corsUrlsFromBaseUrls(
        import.meta.env.VITE_TW_API_BASE_URL,
        import.meta.env.VITE_TW_VAST_API_BASE_URL
      ),
      // null until the user clears signup/validate; read per span so it appears then.
      getUserId: () => session.externalId,
    })
  } catch (error) {
    console.error("Failed to initialise telemetry", error)
  }
}
